export default {
  'forms.buttons.next.label': 'Next',
  'forms.buttons.cancel_request.label': 'Cancel Request',
  'forms.buttons.authenticate_observability_tool.label':
    'Authenticate Observability Tool',
  'forms.buttons.save_authentication.label': 'Save Authentication',
  'forms.buttons.restricted_time_windows.add_window.label': 'Add Time Window'
}
